import script from "./BotLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./BotLogo.vue?vue&type=script&setup=true&lang=js"

import "./BotLogo.vue?vue&type=style&index=0&id=5e9ca404&lang=css"

const __exports__ = script;

export default __exports__